import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

type OnboardingIntroStepProps = {
  onContinue: () => void
}

export function OnboardingIntroStep({ onContinue }: OnboardingIntroStepProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <div className='space-y-6'>
      <div className='space-y-4'>
        <h2 className='text-lg font-semibold tracking-tight'>
          {t('onboarding.intro.title')}
        </h2>
        <p className='leading-relaxed text-muted-foreground'>
          {t('onboarding.intro.stepsOverview')}
        </p>
      </div>
      <div className='flex justify-end'>
        <Button onClick={onContinue}>{t('onboarding.intro.continue')}</Button>
      </div>
    </div>
  )
}
